"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MergingRefiner = exports.Filter = void 0;

var Filter = /*#__PURE__*/function () {
  function Filter() {
    _classCallCheck(this, Filter);
  }

  _createClass(Filter, [{
    key: "refine",
    value: function refine(context, results) {
      var _this = this;

      return results.filter(function (r) {
        return _this.isValid(context, r);
      });
    }
  }]);

  return Filter;
}();

exports.Filter = Filter;

var MergingRefiner = /*#__PURE__*/function () {
  function MergingRefiner() {
    _classCallCheck(this, MergingRefiner);
  }

  _createClass(MergingRefiner, [{
    key: "refine",
    value: function refine(context, results) {
      var _this2 = this;

      if (results.length < 2) {
        return results;
      }

      var mergedResults = [];
      var curResult = results[0];
      var nextResult = null;

      for (var i = 1; i < results.length; i++) {
        nextResult = results[i];
        var textBetween = context.text.substring(curResult.index + curResult.text.length, nextResult.index);

        if (!this.shouldMergeResults(textBetween, curResult, nextResult, context)) {
          mergedResults.push(curResult);
          curResult = nextResult;
        } else {
          (function () {
            var left = curResult;
            var right = nextResult;

            var mergedResult = _this2.mergeResults(textBetween, left, right, context);

            context.debug(function () {
              console.log("".concat(_this2.constructor.name, " merged ").concat(left, " and ").concat(right, " into ").concat(mergedResult));
            });
            curResult = mergedResult;
          })();
        }
      }

      if (curResult != null) {
        mergedResults.push(curResult);
      }

      return mergedResults;
    }
  }]);

  return MergingRefiner;
}();

exports.MergingRefiner = MergingRefiner;